import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-laborer-route",
  "use": "icon-laborer-route-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon-laborer-route\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.225 24.16l-5.065 5.065-6.935 6.935-5.065 5.065a5 5 0 1 1-1.42-1.408l5.077-5.077 6.922-6.923 5.078-5.077a5 5 0 1 1 1.408 1.42zM17 44a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm27-27a3 3 0 1 0 0 6 3 3 0 0 0 0-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol